import React from "react";
import { Button } from "antd";
import { getCodeStatus } from "../../utils/promotionCode";

// Helper function to get the props for different statuses
const getStatusProps = (status) => {
  switch (status) {
    case "pending":
      return {
        text: "Pending",
        color: "var(--ion-color-orange-600)",
        background: "var(--ion-color-orange-100)",
      };
    case "ongoing":
      return {
        text: "Ongoing",
        color: "var(--ion-color-green-600)",
        background: "var(--ion-color-green-100)",
      };
    case "expired":
      return {
        text: "Expired",
        color: "var(--ion-color-red-600)",
        background: "var(--ion-color-red-100)",
      };
    default:
      return {
        text: "Unknown",
        color: "black",
        background: "white",
      };
  }
};

// The Status component to display the status of the promotion code
const PromotionCodeStatus = ({ code }) => {
  const status = getCodeStatus(code); // Determine the status based on the promotion code time
  const { text, color, background } = getStatusProps(status);

  return (
    <Button
      type="text"
      style={{
        fontSize: "1rem",
        color: color,
        background: background,
        padding: "0.5rem 1rem",
      }}
    >
      {text}
    </Button>
  );
};

export default PromotionCodeStatus;
